const StatesArray = [
    ["Alabama","AL"],
    ["Alaska","AK"],
    ["Arizona","AZ"],
    ["Arkansas","AR"],
    ["California","CA"],
    ["Colorado","CO"],
    ["Connecticut","CT"],
    ["Delaware","DE"],
    ["District of Columbia","DC"],
    ["Florida","FL"],
    ["Georgia","GA"],
    ["Hawaii","HI"],
    ["Idaho","ID"],
    ["Illinois","IL"],
    ["Indiana","IN"],
    ["Iowa","IA"],
    ["Kansas","KS"],
    ["Kentucky","KY"],
    ["Louisiana","LA"],
    ["Maine","ME"],
    ["Montana","MT"],
    ["Nebraska","NE"],
    ["Nevada","NV"],
    ["New Hampshire","NH"],
    ["New Jersey","NJ"],
    ["New Mexico","NM"],
    ["New York","NY"],
    ["North Carolina","NC"],
    ["North Dakota","ND"],
    ["Ohio","OH"],
    ["Oklahoma","OK"],
    ["Oregon","OR"],
    ["Maryland","MD"],
    ["Massachusetts","MA"],
    ["Michigan","MI"],
    ["Minnesota","MN"],
    ["Mississippi","MS"],
    ["Missouri","MO"],
    ["Pennsylvania","PA"],
    ["Rhode Island","RI"],
    ["South Carolina","SC"],
    ["South Dakota","SD"],
    ["Tennessee","TN"],
    ["Texas","TX"],
    ["Utah","UT"],
    ["Vermont","VT"],
    ["Virginia","VA"],
    ["Washington","WA"],
    ["West Virginia","WV"],
    ["Wisconsin","WI"],
    ["Wyoming","WY"]
];

const StateCodeToLabelArray: string [][] = [];
StatesArray.forEach(labelToCode => StateCodeToLabelArray.push([labelToCode[1], labelToCode[0]]));

const stateNameToStateAbbr = new Map<string, string>();
const stateAbbrToStateName = new Map<string, string>();

StatesArray.forEach(([stateName, stateAbbr]) => {
    stateNameToStateAbbr.set(stateName.toUpperCase(), stateAbbr);
    stateAbbrToStateName.set(stateAbbr, stateName.toUpperCase());
});

class StateUtil {

    static getStateCodeToLabelArray(): string[][] {
        return StateCodeToLabelArray;
    }

    static getStateAbbr(stateCodeOrName: string): string | null {
        const providedStateCodeOrNameCapitalized = stateCodeOrName.toUpperCase();
        const stateAbbrValue = stateNameToStateAbbr.get(providedStateCodeOrNameCapitalized);
        const stateAbbrValue2 = stateAbbrValue ? stateAbbrValue : (stateAbbrToStateName.has(providedStateCodeOrNameCapitalized) ? providedStateCodeOrNameCapitalized : null);
        return stateAbbrValue2;
    }

    static getStateNameFromAbbr(abbr: string): string | null {
        const stateName = stateAbbrToStateName.get(abbr);
        return stateName ? stateName : null;
    }
}

export {StateUtil}